import { Button } from '@mantine/core';
import { useDiscoveryStore } from '../../../stores/useDiscoveryStore';
import {
  CustomersDashboardIconNotChosen,
  DiscoveryIcon,
  IdeasIcon
} from "../../../icons/x-symbol-svgrepo-com";

interface ExploreButtonProps {
  tabType: 'discovery' | 'ideasSpace' | 'customer360';
  disabled?: boolean;
}

export const ExploreButton = ({ tabType, disabled = false }: ExploreButtonProps) => {
  const setSelectedExploreTab = useDiscoveryStore((s) => s.setSelectedExploreTab);
  const selectedExploreTab = useDiscoveryStore((s) => s.selectedExploreTab);

  const iconComponentMap: { [key: string]: any } = {
    'discovery': DiscoveryIcon,
    'ideasSpace': IdeasIcon,
    'customer360': CustomersDashboardIconNotChosen
  };

  const IconComponent = iconComponentMap[tabType];

  const labelComponentMap: { [key: string]: any } = {
    'discovery': 'Discovery',
    'ideasSpace': 'Ideas space',
    'customer360': 'Customer 360'
  };

  return (
    <Button
      leftIcon={<IconComponent size={16} />}
      onClick={() => setSelectedExploreTab(tabType)}
      variant={'subtle'}
      disabled={ disabled }
      size="sm"
      sx={{
        color: '#212529',
        fontSize: 16,
        fontWeight: 500,
        fontStyle: 'Medium',
        borderRadius: 12,
        '&:disabled': {
          backgroundColor: 'transparent',
          color: '#212529'
        },
        ...( selectedExploreTab === tabType && ({
          fontWeight: 600,
          fontStyle: 'Semi Bold',
          backgroundColor: '#fff',
          boxShadow: '0px 0px 4px 0px #0000001A'
        }))
      }}
    >
      { labelComponentMap[tabType] }
    </Button>
  );
}

export default ExploreButton;